import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import _ from 'lodash';
import moment from 'moment';
import { toLocalDateTimeStr } from 'src/shared/utils/localDateTime';
const FXM_API_URL = config.servers.fxm.url;
export enum ApprovalMethodType {
  PRE = 'PRE', // 사전 승인
  POST = 'POST', // 사후 승인
  SELF = 'SELF', //자가 승인
}
export enum ApproverType {
  ADMIN = 'ADMIN', // 관리자
  MANAGER = 'MANAGER', // 부서장
  USER = 'USER', //직접 선택
  SELF = 'SELF', //로그인 사용자 본인
  POSITION = 'POSITION', //소속 특정 직급 내 선택
  ROLE = 'ROLE', //소속 특정 부서 직무 내 선택
  DEPT_PR = 'DEPT_PR', // 특정 부서 내 직급/직무
}
export enum ApprovalType {
  TAKEOUT = 'TAKEOUT', // PC 반출
  SCREEN = 'SCREEN', // 화면 보안 예외 신청
  DECRYPT = 'DECRYPT', // 암호화해제
  PROVISIONAL = 'PROVISIONAL', // 임시 권한
  PRINT_PERIOD = 'PRINTPOLICY', // 인쇄 예외(기간)
  PRINTPOLICY = 'PRINTPOLICY', // 인쇄 예외(기간)
  PRINT_FILE = 'PRINTFILE', // 인쇄 예외(파일)
  PRINTFILE = 'PRINTFILE', // 인쇄 예외(파일)
  PRINT_CLIENT = 'PRINTCLIENT', // 인쇄 예외(인쇄 실행 시)
  PRINTCLIENT = 'PRINTCLIENT', // 인쇄 예외(인쇄 실행 시)
  SCANEXEMPT = 'SCANEXEMPT', //검사 예외
  SCANLEDGER = 'SCANLEDGER', // 관리대장
  ENCMAIL = 'ENCMAIL', // 암호화 해제(메일 반출)
  EXCHANGEFULL = 'EXCHANGEFULL', // 외부 공유(편집 허용)
  EXCHANGEOFFLINE = 'EXCHANGEOFFLINE', // 외부 공유(읽기 전용)
}
export enum StatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export enum ApprovalStatusType {
  APPLY = 'APPLY',
  PROGRESS = 'PROGRESS',
  APPROVAL = 'APPROVAL',
  REJECT = 'REJECT',
  CANCEL = 'CANCEL',
}
export enum LimitType {
  LIMIT = 'LIMIT',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
export interface ApproverDto {
  approvalNo: string; // 결재 고유 번호
  step: number; // 승인 단계
  approverType: string | null; // 승인권자 유형
  userId: string; // 승인자 ID
  userName: string; // 승인자 이름
  deptCode: string; // 승인자 부서코드
  deptName: string; // 승인자 부서명
  positionCode: string; // 직급코드
  positionName: string; // 직급 명
  roleCode: string; // 직무 코드
  roleName: string | null; // 직무 명
  proxyNo?: string | null; // 대리 승인이 있을 시 not null, 대리승인 고유 번호
  updatedTs: number;
  isCaiEnabled?: 0 | 1; // 민감 정보 검출 사용 유무(int), 1 사용, 0 미사용(기본)
}
export type ProgressApproverDto = ApproverDto;
export interface CompleteApproverDto extends ApproverDto {
  actionLogNo: string;
  approvalMethod: string;
  approvalStatus: 'APPLY' | 'PROGRESS' | 'APPROVAL' | 'REJECT' | 'CANCEL';
  approvalRemark: string;
  actorIp: string;
  otherUserId: string | null;
  otherUserName: string | null;
  otherPositionCode: string | null;
  otherPositionName: string | null;
  otherDeptCode: string | null;
  otherDeptName: string | null;
  otherRoleCode: string | null;
  otherRoleName: string | null;
}
// 민감정보 관련 -- Start --
export interface DetectedInfo {
  fileUuid: string;
  subUuid: string;
  patternId: number;
  patternName: string;
  detectedType: number;
  detectedCount: number;
  detectedData: string;
  updatedTs: number;
  dataDelimiter: string;
}
export interface DetectedFileInfo {
  approvalNo: string;
  approvalType: string;
  userId: string;
  fileUuid: string;
  fileName: string;
  detectStatus: 'DETECTED' | 'NONE' | 'ERROR';
  detectFormatCode: string;
  detectFormat: string;
  errorType: string | null;
  errorCode: string | null;
  startTs: number;
  endTs: number;
  totalPatternCount: number;
  totalPatternDetailCount: number;
  detectedInfos: DetectedInfo[];
}
// 민감정보 관련 -- End --
interface TraceInfoNodeIndo {
  userCode: string;
  traceId: string;
  dsd: string;
  logTime: string;
  pID: string;
}
/*
* error message 
"SUCESS": "다운로드 가능",
"DOWNLOAD_EXCEED": "다운로드 횟수 초과",
"ALREADY_EXPIRED": "다운로드 기간 만료",
"NOT_FOUND_UPLOAD_DATA": "파일이 업로드 될 때 디비에 저장된 파일 메타 데이터를 찾지 못함(서버 오류)",
"NOT_FOUND_FILE": "업로드 된 파일 데이터를 찾지 못함(서버 오류)",
"FAILED_TO_DECRYPTED": "복호화 실패한 파일을 받으려고 할 때(서버 오류)",
"INTERNAL_SERVER_ERROR": "알수없는 서버 오류(서버 오류)"
*/
export interface FileInfoDto {
  approvalNo: string; // 결재 고유 번호
  approvalType: string;
  userId: string;
  fileUuid: string; // 파일 고유 ID
  fileType: number;
  fileName: string;
  contentId: string;
  contentName: string; //파일 원본 파일 명
  filePath: string | null;
  fileSize: number;
  dsdCode: string;
  expiredTs: number; //파일 만료 시간(삭제될 시간)
  downloadCount: number; //파일 다운로드 횟수
  allowDownloadCount: number; // 허용된 파일 다운로드 횟수
  updatedTs: number;
  error: string | null; // 파일 에러 유무. 에러 존재 시 NOT NULL, 결재선 우선 순위에 없을 시 NOT_ALLOWED
  code: string;
  stepScope: number; // 파일 결재선 우선 순위 0 ~ N, 우선 순위에 포함되지 않을 시 -1
  decryptSuccess: boolean;
  fileTypeEx: string;
}
export interface FileDetailsInfo extends FileInfoDto {
  codeName: string;
  contentInfo: {
    fileUuid: string;
    fileType: number;
    cpId: string;
    contentId: string;
    contentName: string;
    curContentName: string | null;
    traceInfos: {
      nodeCount: number;
      node1: TraceInfoNodeIndo;
      node2: TraceInfoNodeIndo;
      node3: TraceInfoNodeIndo;
      node4: TraceInfoNodeIndo;
      node5: TraceInfoNodeIndo;
    };
    writerId: string;
    writerName: string;
    writerDeptCode: string;
    writerDeptName: string;
    ownerId: string;
    ownerName: string;
    ownerDeptCode: string;
    ownerDeptName: string;
    documentClassName: string;
    documentClassCode: string;
    traceInfo: string;
  };
  fileTypeDetail: null;
}
export interface DownloadHistoryInfo {
  action: string;
  approvalNo: string;
  userId: string;
  userName: string;
  fileUuid: string;
  updatedTs: number;
  downloadNo: string;
  userIp: number;
  userIpText: string;
  adminRemark: string | null;
}
export interface ApprovalDto {
  code: string; // 정책 고유 코드
  approvalStep: number; // 신청 단계(정책에 따라 1~N까지 나뉨, 자가 승인일 경우 1)
  currentStep: number; //신청 시 단계, 1 고정
  approvalType: ApprovalType; // TAKEOUT, PROVISIONAL, DECRYPT, SCREEN, PRINTPOLICY, PRINTFILE, PRINTCLIENT, SCANEXEMPT, SCANLEDGER, ENCMAIL
  status: string; // (APPLY : 신청, PROGRESS : 진행중, APPROVAL : 승인, REJECT : 반려, CANCEL : 취소)
  approvalMethod: string; // 승인 방법 (PRE : 사전 승인, POST : 사후 승인, SELF : 자가 승인)
  remark: string; // 사유
  approvers: ApproverDto[];
}
export interface DeptPrDto {
  deptCode: string;
  roleCodes: string[];
  positionCodes: string[];
}
export interface ApproverListDto {
  code: string;
  approverStep: number; // 신청 단계 [단계]
  roles: string[]; //직무 코드 list [직무]
  positions: string[]; //직급 코드 list [직급]
  userIds: string[]; //사용자 id list [다른 사용자]
  managers: string[]; //관리자 id list
  depth: number; // -1;  [미사용시 -1]  이게 부서장?
  self: boolean; //본인 유무
  deptPr: DeptPrDto[]; // 부서별 직급 직무
}
export type ApprovalListDto = Omit<ApproverListDto, 'code'>;
export interface ApprovalDetailDto extends ApprovalDto {
  approvalNo: string;
  userId: string;
  userName: string;
  deptCode: string;
  deptName: string;
  positionCode: string;
  positionName: string;
  roleCode: string;
  roleName: string;
  applyDate: number;
  actorIp: string;
  updatedTs: number;
  progressApprovers: ProgressApproverDto[];
  completeApprovers: CompleteApproverDto[];
}
export interface ApprovalDetailEntity extends ApprovalDetailDto {
  applyDateStr: string;
  updatedTsStr: string;
}
export const toApprovalDetailDtoToEntity = (dto: ApprovalDetailDto): ApprovalDetailEntity => {
  return {
    ...dto,
    applyDateStr: dto.applyDate > 0 ? toLocalDateTimeStr(dto.applyDate) : '',
    updatedTsStr: dto.updatedTs > 0 ? toLocalDateTimeStr(dto.updatedTs) : '',
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
  };
};
export interface ApprovalDetailReqDto {
  approvalTypes: string[];
  approvalMethods: string[];
  startDate: number;
  endDate: number;
}
export interface ApprovalDoneDetailReqDto extends ApprovalDetailReqDto {
  approvalStatuses: string[];
}
export const defaultApprovalDetailReqDto = (): ApprovalDetailReqDto => {
  return {
    approvalTypes: [],
    approvalMethods: [],
    startDate: moment().subtract(6, 'months').startOf('day').valueOf(),
    endDate: moment().endOf('day').valueOf(),
  };
};
export const defaultApprovalDoneDetailReqDto = (): ApprovalDoneDetailReqDto => {
  return {
    ...defaultApprovalDetailReqDto(),
    approvalStatuses: [],
  };
};
export interface ApprovalDetailReqServerDto {
  approvalTypes: string[];
  approvalMethods: string[];
  orderBy: string;
  startDate: number | null;
  endDate: number | null;
  offset: number;
  limit: number;
}
export interface ApprovalDoneDetailReqServerDto extends ApprovalDetailReqServerDto {
  approvalStatuses: string[];
}
export interface RequestApprovalDto {
  userId: string; // 승인권자 ID
  approvalNo: string; // 결재 고유번호
  status: string;
  approvalMethod: string;
  remark: string;
  approvalType: string;
  proxyNo: string | null;
}
interface ApprovalDetailApi {
  pendinglist(
    reqDto: ApprovalDetailReqDto,
    offset: number,
    limit: number
  ): Promise<ApprovalDetailEntity[]>;
  donelist(
    reqDto: ApprovalDoneDetailReqDto,
    offset: number,
    limit: number
  ): Promise<ApprovalDetailEntity[]>;
  approvalOrReject(dto: RequestApprovalDto): Promise<ApprovalDetailDto>;
}
class ApprovalDetailServerApi implements ApprovalDetailApi {
  async pendinglist(
    reqDto: ApprovalDetailReqDto,
    offset: number,
    limit: number
  ): Promise<ApprovalDetailEntity[]> {
    const serverReqDto: ApprovalDetailReqServerDto = {
      ...reqDto,
      startDate: reqDto.startDate !== 0 ? moment(reqDto.startDate).startOf('m').valueOf() : null,
      endDate: reqDto.endDate !== 0 ? moment(reqDto.endDate).endOf('m').valueOf() : null,
      limit: limit,
      offset: offset,
      orderBy: 'DESC',
    };
    const resp = await axios.post<ApprovalDetailDto[]>(
      `${FXM_API_URL}/api/approval/pendingList`,
      serverReqDto
    );
    return Promise.resolve(
      _.cloneDeep(resp.data.map((serverDto) => toApprovalDetailDtoToEntity(serverDto)))
    );
  }
  async donelist(
    reqDto: ApprovalDoneDetailReqDto,
    offset: number,
    limit: number
  ): Promise<ApprovalDetailEntity[]> {
    const serverReqDto: ApprovalDoneDetailReqServerDto = {
      ...reqDto,
      startDate: reqDto.startDate !== 0 ? moment(reqDto.startDate).startOf('m').valueOf() : null,
      endDate: reqDto.endDate !== 0 ? moment(reqDto.endDate).endOf('m').valueOf() : null,
      limit: limit,
      offset: offset,
      orderBy: 'DESC',
    };
    const resp = await axios.post<ApprovalDetailDto[]>(
      `${FXM_API_URL}/api/approval/doneList`,
      serverReqDto
    );
    return Promise.resolve(
      _.cloneDeep(resp.data.map((serverDto) => toApprovalDetailDtoToEntity(serverDto)))
    );
  }
  async approvalOrReject(dto: RequestApprovalDto): Promise<ApprovalDetailEntity> {
    const resp = await axios.post<ApprovalDetailDto>(`${FXM_API_URL}/api/approval`, dto);
    return Promise.resolve(toApprovalDetailDtoToEntity(resp.data));
  }
}
const approvalDetailApi = new ApprovalDetailServerApi();
export default approvalDetailApi;
